module.exports = __webpack_public_path__ + "img/yaya.1616cb38.png";